import { Stack } from '@mui/system';
import ProjectList from './components/ProjectList/ProjectList';
import PitchesList from './components/PitchesList/PitchesList';
import Stats from './components/Stats/Stats';
import EventsCard from './components/EventsCard';

type Props = {};

const Homescreen = (props: Props) => (
  <Stack spacing={5} width="100%" height="100%">
    <Stats />
    <ProjectList />
    <PitchesList />
    <EventsCard />
  </Stack>
);

export default Homescreen;
